import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Venue | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Venue"
          content="For Participants"
          contentTwo="Venue"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>

          <div className="row row-content align-items-center">
            <div className="col-12">
              <h2>Venue(Crowne Plaza Sanya City Center, 三亚中心皇冠假日酒店)</h2>
              <hr></hr>


              {/* <h3>Location</h3>
              <p className="" home-p text-justify>
                会议地点介绍...
                The Zhongguanyuan Global Village PKU (Beijing Daxue Zhongguan Xinyuan) is made up of
                accommodation, catering, conference, teaching, sports and recreational facilities.
                ....
              </p> */}
              {/* <div className="container-fluid">
                <div className="d-flex flex-wrap justify-content-center">
                  一些图片
                   <div class="card gallery_card border-0">
                                        <img class="card-img-venue" src="https://pavo.elongstatic.com/i/tHotel800_600/000dl4fa.jpg" alt="Card image cap">
                                    </div>
                                    <div class="card gallery_card border-0">
                                        <img class="card-img-venue" src="https://pavo.elongstatic.com/i/tHotel800_600/000e5Ye1.jpg" alt="Card image cap">
                                    </div> 
                </div>
              </div> */}
              {/* <h3>About the venue hotel</h3> */}
              <br></br>
              <h5>Crowne Plaza Sanya City Center(三亚中心皇冠假日酒店)</h5>
              <p>
                Crowne Plaza Sanya City Center is conveniently located on Yuya Road, a scenic thoroughfare running along Yulin Harbor. We are 17 kilometers from Sanya Phoenix International Airport and 11 kilometers from Sanya Railway Station. Nearby attractions and points of interest include Sanya International Yacht Club, Bar Street and Sanya International Shopping Center. Putting you close to nearby Dadonghai Beach, Mountainous Luhuitou Park and popular Sanya No.1 Market Sanya, where you can enjoy all of the authentic flavors of Hainan. Sanya is China`&apos;s tropical city, welcoming you to paradise.
                <br></br><br></br>
                The hotel offers 490 finely appointed guest rooms and suites, all with flat-screen television, satellite channels, a spacious work desk with ergonomic seating and wireless high-speed internet access. Crowne Plaza Executive Lounge is located on the 16th floor, and provides personalized services to meet the unique needs of discerning business and leisure travelers.
                <br></br><br></br>
                For a perfect night`&apos;s sleep, the hotel offer the Crowne Plaza Sleep Advantage program providing in-room options such as ergonomic pillow selection (facing-up,facing-side or facing-down pillow),Crowne Style or Lavender aromatherapy and your choice of warm milk or red wine. Sleep Advantage items are delivered within 15 minutes upon request.

                {/* For more information about the hotel, please visit the website: https://www.ihg.com/crowneplaza/hotels/us/en/sanya/syxcc/hoteldetail */}
              </p>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/accom9.png" />
                    </td>
                    <td width="50%">
                      <img src="images/sanya/accom10.png" />
                    </td>
                  </tr>
                </table>
              </div>
              <hr></hr>
              <h3>Hotel Information</h3>
              <ul>
                <li>
                  Hotel Address : No.3 YuyaRoad, Sanya, Hainan Province.

                </li>
                <li>
                  Hotel Reservation Telephone : 400-830-2766 (Busy or no answer,
                  online booking please!)
                </li>
                {/* <li>
                  Hotel Front Desk Telephone: 未确定 (Catering,
                  conference,sauna,entertainment, Invoice, traffic)
                </li> */}
              </ul>
              <hr></hr>

              <h3>Transportation</h3>
              <p className="home-p text-justify">
                Hotel Address : No.3 YuyaRoad, Sanya, Hainan Province.

              </p>
              <div className="row">
                <iframe
                  src="https://map.baidu.com/search/%E4%B8%89%E4%BA%9A%E4%B8%AD%E5%BF%83%E7%9A%87%E5%86%A0%E5%81%87%E6%97%A5%E9%85%92%E5%BA%97/@12191956,2052210,19z?querytype=s&da_src=shareurl&wd=%E4%B8%89%E4%BA%9A%E4%B8%AD%E5%BF%83%E7%9A%87%E5%86%A0%E5%81%87%E6%97%A5%E9%85%92%E5%BA%97&c=121&src=0&pn=0&sug=0&l=13&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1"
                  width={900}
                  height={600}
                  loading="lazy"
                ></iframe>
              </div>
              <br></br>
              <h4>Route 1: Airport to hotel</h4>
              You can take bus No. 8 / No. 4 / No. D9 to No.42 / No. D9 to No.4 / No. 36  from Sanya Phoenix International Airport. The journey takes 70-90 minutes.
              <tr></tr><br></br>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/airport_to_hotel.png" />
                    </td>
                    {/* <td width="50%">
                      <img src="images/sanya/accom11.png" />
                    </td> */}
                  </tr>
                </table>
              </div>
              <br></br>
              <h4>Route 2: Train station to hotel</h4>
              You can take bus No. 42 / No. 4 / No. 15 / No. 10 from Sanya Station. The journey takes 40-50 minutes.

              <tr></tr>     <br></br>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/station_to_hotel.png" />
                    </td>
                    {/* <td width="50%">
                      <img src="images/sanya/accom11.png" />
                    </td> */}
                  </tr>
                </table>
              </div>
              {/* <p className="home-p text-justify">
                路线
              </p> */}
              <hr></hr>

              {/* <h3>About Peking University</h3>
              <p className="home-p text-justify">
                Peking University (PKU)(informally known as Beida), is a major research university in
                Beijing, China, and a member of the elite C9 League of Chinese universities. It is
                perennially ranked as one of the top academic institutions in China, Asia, and
                worldwide.The
                first modern national university established in China, it was founded during the late
                Qing
                Dynasty in 1898 as the Imperial University of Peking and was the successor of the
                Guozijian,
                or Imperial College The university&apos;s romanized name, Peking, retains the older
                transliteration of &apot;Beijing&apot; that has been superseded in most other contexts.
                 <div className="text-center">
                  一些图片
                   <img class="img-fluid img-thumbnail" style="width: 90%; height: 600px;"
                                    src="./img/pku_scene.png" /> 
                </div> 
            </p> */}
            </div>



          </div>



          {/* <UnderConstruction/> */}
          {/* <div className="entry-content">
          <p>&nbsp;</p>
          <h5>
          The venue for 2022 International Conference on Swarm Intelligence (ICSI) is to be announced.
          </h5>
          <p>&nbsp;</p>
          <h4>About the venue hotel</h4>
          Blue Horizon Hotel (Qingdao Shilaoren International Exhibition Center
          store) is affiliated to Shandong Blue Horizon Hotel Group, located in
          Laoshan District, Qingdao City, and shilao tourist resort in the
          south. It is an important part of Shandong International Conference
          and Exhibition Center. The rooms are distributed on the 3rd to 9th
          floors, with spacious and bright rooms, equipped with complete
          equipment such as broadband network, satellite TV, international
          direct dial telephone, small bar, electronic safe, etc., and equipped
          with transparent toilet and modern home facilities, showing luxury and
          fashion. It is an ideal choice for you to stay in business and life.
          <p>&nbsp;</p>
          <h4>About the university</h4>
          Ocean University of China (OUC) is a comprehensive university with
          particular strengths in oceanography and fisheries science. We have
          four campuses – Yushan, Fushan, Laoshan and Huangdao, which is
          currently under construction – all of which are united under our motto
          “Ocean embraces all streams; exploring promises reaching far.” OUC was
          one of the first universities approved to confer undergraduate and
          postgraduate degrees by the State Academic Degree Committee and it now
          offers courses in science, engineering, agronomy (fisheries),
          pharmaceutics, economics, management, liberal arts, law, education,
          history, and art. In 2017 it was included in China’s plan of building
          &quot;Double First-Rate&quot; universities, having previously also
          been on the list of &quot;Project 985&quot; universities (a list of
          China’s top 40 universities) and &quot;Project 211&quot; institutions
          (of China’s top 100 universities). It is now the recipient of
          significant national and provincial support and funding, which
          supports its bid to become a world class university.
          <p>&nbsp;</p>
          <h4>Location</h4>
          Address: No. 9-2, Miaoling Road, Laoshan District, Qingdao, China.
          Please refer to the{" "}
          <a href="https://goo.gl/maps/99Co7WDgMxujiNZM8">Google</a> or{" "}
          <a href="https://j.map.baidu.com/c5/tYK">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E9%9D%92%E5%B2%9B%E8%93%9D%E6%B5%B7%E5%A4%A7%E9%A5%AD%E5%BA%97(%E5%B4%82%E5%B1%B1%E5%BA%97)/@13411516,4290391,17z?uid=341c35de82aa8ca7e6073875&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>
          <p>&nbsp;</p>
        </div> */}
        </EmptyTwo>
        {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Venue | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Venue"
          content="For Participants"
          contentTwo="Venue"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Venue;
